<template>
  <!-- Overlay Start -->
  <div class="overlay"></div>
  <!-- Overlay End -->
  <!-- Page Banner Start -->
  <div class="section page-banner">
    <div class="container">
      <div class="setup-password">
        <div v-if="token" class="card">
          <h2>Pick a password</h2>

          <div class="password-wrapper">
            <input
              :type="showPassword ? 'text' : 'password'"
              v-model="password"
              placeholder="Password"
              @input="checkPasswordStrength"
            />
            <span class="eye-icon" @click="togglePassword">
              {{ showPassword ? '🙈' : '👁️' }}
            </span>
          </div>

          <div class="strength-bar">
            <div
              class="bar"
              v-for="(bar, index) in 4"
              :key="index"
              :class="{ filled: index < strengthLevel }"
            ></div>
          </div>

          <p class="strength-label" v-if="password">{{strengthLevelMsg[strengthLevel]}}</p>

          <!-- <label class="checkbox-container">
            <input type="checkbox" v-model="agreed" />
            I agree with Visualping's Terms and Privacy Policy
          </label> -->

          <button :disabled="password.length<=2" @click="submitPassword" style="margin-top: 10px;">
            Continue
          </button>

          <p v-if="message" style="margin-top: 10px;text-align: center;">{{ message }}</p>
        </div>

        <div v-else>
          Unauthorized
        </div>
      </div>

    </div>
    
  </div>
  
</template>

<script>
import {setupPassword} from '@/services/bulkUserService';
import { jwtDecode } from "jwt-decode";
export default {
  name: 'MemberPassword',
  data() {
    return {
      password: '',
      message: '',
      token: null,
      token_info: null,
      showPassword: false,
      strengthLevel: 0,
      strengthLevelMsg:['Use Strong password', 'Weak password', 'Good Password', 'Strong Password']
    };
  },

  mounted(){
    this.token = this.$route.query.token;
    this.token_info = jwtDecode(this.token);
    console.log(this.token_info);
  },

  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword;
    },

    checkPasswordStrength() {
      const length = this.password.length;
      if (length >= 10) this.strengthLevel = 4;
      else if (length >= 8) this.strengthLevel = 3;
      else if (length >= 6) this.strengthLevel = 2;
      else if (length > 0) this.strengthLevel = 1;
      else this.strengthLevel = 0;
    },
    
    async submitPassword() {
      console.log(this.token);
      if (!this.token) {
        this.message = 'Invalid or expired token.';
        return;
      }

      try {
        console.log(this.token_info.pkg_id);
        let res = await setupPassword(this.token, this.password, this.token_info.pkg_id);
        this.message = res.data;
      } catch (error) {
        // console.error(error);
        this.message = error.response.data;
      }
    },
  },
};
</script>

<style scoped>
.setup-password {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
/*  background-color: #f6f8fa;*/
  font-family: 'Segoe UI', sans-serif;
}

.card {
  background: #f7fdfb; /* changed from white */
  border-radius: 16px;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.04);
  padding: 32px;
  width: 100%;
  max-width: 400px;
  box-sizing: border-box;
}

.card h2 {
  font-size: 20px;
  margin-bottom: 20px;
  text-align: center;
  color: #333;
}

.password-wrapper {
  position: relative;
  margin-bottom: 12px;
}

.password-wrapper input {
  width: 100%;
  padding: 12px 42px 12px 14px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 10px;
  outline: none;
}

.eye-icon {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 18px;
}

.strength-bar {
  display: flex;
  gap: 4px;
  margin-top: 6px;
  margin-bottom: 4px;
}

.bar {
  flex: 1;
  height: 6px;
  background-color: #e0e0e0;
  border-radius: 4px;
  transition: background 0.3s;
}

.bar.filled {
  background-color: #00c29b;
}

.strength-label {
  text-align: center;
  font-size: 14px;
  color: #00c29b;
  margin-bottom: 16px;
}

.checkbox-container {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #444;
  margin-bottom: 20px;
}

.checkbox-container input {
  margin-right: 8px;
  transform: scale(1.1);
}

button {
  width: 100%;
  padding: 12px;
  font-size: 16px;
  border: none;
  border-radius: 12px;
  background-color: #cfe1fd;
  color: white;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

button:disabled {
  background-color: #e0e0e0;
  cursor: not-allowed;
}

button:not(:disabled) {
  background-color: #2e90fa;
}

</style>
